<template>
  <div style="font-size: 0.9rem;margin-left: 20px;margin-right: 30px;">
    <div style="font-size: 0.9rem;margin-bottom: 10px;">
      <el-row style="border-bottom: 1px solid rgba(41, 155, 255, .2);padding: 35px 0 0 0;">
        <ul class="row-ul">
          <li class="row-li">
            <div class="d-inline-block" style="width: 80px;">历史范围：</div>
            <el-date-picker
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              range-separator="-"
              size="mini"
              start-placeholder="开始日期"
              style="width:230px"
              type="daterange"
              v-model="screenDate"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </li>
        </ul>
        <ul class="row-ul">
          <li class="row-li">
            <div class="d-inline-block" style="width: 80px;">类型：</div>
            <el-select
              v-model="form.businessType"
              placeholder="请选择"
              size="mini"
              style="padding-bottom: 5px;width: 230px;">
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </li>
        </ul>
        <ul class="row-ul">
          <li class="row-li">
            <div class="d-inline-block" style="width: 80px;">通知方式：</div>
            <el-select
              placeholder="请选择"
              size="mini"
              style="padding-bottom: 5px;width: 230px;"
              v-model="form.category">
              <el-option
                :key="item.id"
                :label="item.name"
                :value="item.id"
                v-for="item in categoryList">
              </el-option>
            </el-select>
          </li>
        </ul>
        <ul class="row-ul">
          <li class="row-li">
            <div class="d-inline-block" style="width: 80px;">通知内容：</div>
            <el-input placeholder="" size="mini" style="width: 230px;" v-model="form.content"></el-input>
          </li>
        </ul>
        <ul class="row-ul" style="float: right!important;padding-bottom: 10px;">
          <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="float: right">
            <el-button size="mini" :loading="isSelect"
                       style="float:right;font-weight:bold;padding:9px 25px;color:rgba(7, 230, 248, 1);"
                  @touchstart.native="filtrateForm"   @click.native="filtrateForm">查询
            </el-button>
          </el-col>
        </ul>
      </el-row>
    </div>
    <el-row style="margin-top: 10px;">
      <el-button :loading="isDownload" class="button" size="mini"
                 style="float: right; margin-bottom: 10px;height: 30px;" @touchstart.native="exportExcel" @click.native="exportExcel">
        <img src="@/assets/images/icon/excel.png" style="margin-bottom: 4px;">
        <span style="margin-left: 5px;color: #299FFB">导出</span>
      </el-button>
      <el-table
        :data="tableData"
        height="55vh"
        border
        style="width: 100%">
        <el-table-column
          label="类型"
          prop="businessType">
        </el-table-column>
        <el-table-column
          label="接收人"
          prop="receiver">
        </el-table-column>
        <el-table-column
          label="通知内容"
          width="650">
          <template slot-scope="scope">
            <el-collapse>
              <el-collapse-item
                :title="scope.row.content.length > 50 ? scope.row.content.substring(0,50)+ '  ......':scope.row.content.substring(0,50)">
                <div v-html="scope.row.content"></div>
              </el-collapse-item>
            </el-collapse>
          </template>
        </el-table-column>
        <el-table-column
          label="是否成功"
          prop="isSuccess">
          <template slot-scope="scope">
            <span>{{ scope.row.isSuccess | changeStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="结果描述"
          prop="resultDesc"
          width="350">
        </el-table-column>
        <el-table-column
          label="发送时间"
          prop="sentTime">
        </el-table-column>
      </el-table>
    </el-row>
    <el-row v-if="dataTotal>10" style="margin-top: 15px;text-align: center;">
      <el-pagination
        :current-page.sync="form.pageCurrent"
        :page-size="form.pageSize"
        :total="dataTotal"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import {listByPage, smsOperationLog} from "@/network/notice-record";
//import {downloadBlobFile} from '@/constant/export-file';

export default {
  name: "SmsOperationLog",
  data() {
    return {
      isSelect: false,
      isDownload: false,
      form: {
        pageCurrent: 1,
        pageSize: 10,
        category: "",
        startDate: '',
        endDate: '',
        content: '',
        businessType: '',
      },
      screenDate: '',
      dataTotal: 0,
      tableData: [],
      categoryList: [{id: '', name: '全部'}, {id: 'sms', name: '短信'}, {id: 'email', name: '邮件'}, {
        id: 'phone',
        name: '电话'
      }],
      typeList: [
        {id: '1', name: '超过上限告警'},
        {id: '2', name: '超过下限告警'},
        {id: '3', name: '恢复告警'},
        {id: '4', name: '主机离线恢复'},
        {id: '5', name: '主机离线'},
        {id: '6', name: '设备离线恢复'},
        {id: '7', name: '设备离线'},
      ],
    }
  },
  created() {
    this.getData(this.form);
  },
  filters: {
    changeStatus(params) {
      switch (params) {
        case true:
          return '成功';
        case false:
          return '失败';
      }
    }
  },
  methods: {
    // excel导出
    exportExcel() {
      this.isDownload = true;
      let exportForm = this.form;
      exportForm.pageCurrent = 1;
      exportForm.pageSize = 10000;
      this.$message.info('文件生成中，稍后请前往下载列表中下载文件!')
      smsOperationLog(exportForm).then(res => {
        this.isDownload = false;
        if (res) {
          /*downloadBlobFile(res, "通知发送日志");*/
        }
      });
    },
    // 获取数据
    getData(params) {
      console.log(params);
      this.isSelect = true;
      listByPage(params).then(res => {
        if (res.code === 0) {
          // 列表数据
          let bln = res.data == null;
          this.tableData = bln ? null : res.data.records;
          // 总数
          this.dataTotal = bln ? 0 : res.data.total;
          // 每页数
          this.form.pageSize = bln ? 10 : res.data.size;
          this.form.pageCurrent = bln ? 1 : res.data.current;
        }
        this.isSelect = false;
      })
    },
    handleCurrentChange(val) {
      //当前为第几页时调用getData()显示第几页数据
      this.form.pageCurrent = val;
      this.form.pageSize = 10;
      this.getData(this.form);
    },
    filtrateForm() {
      // 组装表单
      this.form.pageCurrent = 1;
      this.form.pageSize = 10;
      if (this.screenDate != null && this.screenDate.length > 0) {
        let startTime = this.screenDate[0];
        let endTime = this.screenDate[1];
        this.form.startDate = startTime;
        // 设置结束时间
        this.form.endDate = endTime;
      } else {
        this.form.startDate = '';
        // 设置结束时间
        this.form.endDate = '';
      }
      this.getData(this.form);
    },
    statusChange(val) {
      console.log(val);
      this.form.isSuccess = val.id;
    },
    showContent(content) {
      this.$alert(content, '内容详情', {
        dangerouslyUseHTMLString: true
      });
    }
  }

}
</script>

<style scoped>
.row-li {
  line-height: 20px;
  list-style: none;
  padding: 0;
  float: left !important;
  margin-right: 20px;
}

.row-ul {
  list-style: none;
  padding: 0;
  margin-bottom: -5px;
  float: left !important;
}
</style>
